<template>
  <el-dialog :visible="true" top="15vh" :before-close="close">
    <div slot="title" style="text-align: center">
      <span class="fz18 fw500" style="font-weight: bolder">申请结果</span>
    </div>
    <el-row type="flex" justify="center">
      <img style="width:130px;height:130px" :src="iconSuccess" alt="" />
    </el-row>
    <p class="fz24 tac">开票申请成功</p>

    <p class="tac">您的开票申请已提交</p>

    <table class="app-detail" v-if="info">
      <tbody>
        <tr>
          <td class="app-detail-item-td">
            <div class="app-detail-item-title pb16 pt16 fz16">开票信息</div>
          </td>
          <td class="app-detail-item-td"></td>
        </tr>
        <tr>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label">开票人数：</label>

            <div style="overflow: hidden">{{ info.invoiceNumber }} 人</div>
          </td>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label" style="margin-left:100px">
              价税合计：
            </label>

            <div style="overflow: hidden">
              {{ info.totalAmount | moneyFixed }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="app-detail-item-td">
            <div class="app-detail-item-title pb8 pt16 fz16">发票邮寄信息</div>
          </td>
          <td class="app-detail-item-td"></td>
        </tr>
        <tr>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label">收件人：</label>

            <div style="overflow: hidden">{{ info.receiptFullName }}</div>
          </td>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label" style="margin-left:100px">
              联系方式：
            </label>

            <div style="overflow: hidden">{{ info.receiptPhone }}</div>
          </td>
        </tr>
        <tr>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label">发票邮寄地址：</label>

            <div style="overflow: hidden">{{ info.receiptAddress }}</div>
          </td>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label" style="margin-left:100px">
              收件地址名称：
            </label>

            <div style="overflow: hidden">{{ info.addressName }}</div>
          </td>
        </tr>
        <tr>
          <td class="app-detail-item-td">
            <label class="app-detail-item__label">电子邮箱：</label>

            <div style="overflow: hidden">{{ info.email }}</div>
          </td>
          <td class="app-detail-item-td"></td>
        </tr>
      </tbody>
    </table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="close">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import iconSuccess from '@/assets/kaihuchenggong.png';

export default {
  name: 'ApplyForInvoicingRespond',
  cname: '申请委托代开发票|结果',
  props: {
    resInfo: {
      type: [Object],
      default: () => ({
        invoiceSubmitToSave: {
          invoiceNumber: 0, //开票人数
          totalAmount: 0 // 价税合计
        },
        csoReceiptAddress: {
          id: 0,
          enterpriseId: 0,
          receiptFullName: '-', // 收件人
          receiptPhone: '-', //联系方式
          receiptAddress: '-', //发票邮寄地址
          addressName: '', // 收件地址名称
          email: '', // 电子邮箱
          isDefault: 0,
          createDt: 0
        }
      })
    }
  },
  computed: {
    info() {
      return {
        ...this.resInfo.invoiceSubmitToSave,
        ...this.resInfo.csoReceiptAddress
      };
    }
  },
  data() {
    return {
      iconSuccess: iconSuccess
    };
  },
  methods: {
    close() {
      this.remove();
    }
  }
};
</script>
<style lang="scss">
.app-detail {
  //border: 1px dotted #585858;
  width: 90%;
  text-align: left;
  margin: 0 auto;
  border-collapse: collapse;
}

.app-detail-item__label {
  text-align: right;
  width: 7rem;
  display: inline-block;
  float: left;
}

.app-detail-item-td {
  overflow: hidden;
  width: 50%;
  border: 1px dotted #fff;
}
</style>
